import { OK, CREATED, UNPROCESSABLE_ENTITY, UNAUTHORIZED } from '../util'

const state = {
    member: null,
    fail_count: 0,
    timerId: null
}

const getters = {
    vintageCurves: () => {
        var rgb = function (x) {
                return -12 * Math.sin( x * 2 * Math.PI / 255 ) + x;
            },
            r = function(x) {
                return -0.2 * Math.pow(255 * x, 0.5) * Math.sin(Math.PI * (-0.0000195 * Math.pow(x, 2) + 0.0125 * x ) ) + x;
            },
            g = function(x) {
                return -0.001045244139166791 * Math.pow(x,2) + 1.2665372554875318 * x;
            },
            b = function(x) {
                return 0.57254902 * x + 53;
            },
            c = {r:[],g:[],b:[]};
        for(var i=0;i<=255;++i) {
            c.r[i] = r( rgb(i) );
            c.g[i] = g( rgb(i) );
            c.b[i] = b( rgb(i) );
        }
        return c;
    }
}

const mutations = {
    setMember (state, member) {
        state.member = member
    },
}

const actions = {
    async getMember (context, data) {
        const response = await axios.post('/api/member/list', data)

        if (response.status === OK) {
            context.commit('setMember', response.data)
        }
        if (response.status === UNAUTHORIZED) {
            state.fail_count++
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
